import { Button, Modal } from "@simplybusiness/mobius";
import type { ResyncConfirmationModalProps } from "./types";

export const ResyncConfirmationModal = ({
  isOpen,
  isLoading,
  onConfirm,
  onClose,
}: ResyncConfirmationModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <Modal.Header>Resync your quote</Modal.Header>
    <Modal.Content>
      In resyncing your coverage you will be taken back to your original quote
      selection.
      <div className="mobius-payment-options__dialog-actions">
        <Button
          variant="secondary"
          size="sm"
          isLoading={isLoading}
          isDisabled={isLoading}
          onPress={onConfirm}
        >
          Resync your quote
        </Button>
        <Button
          variant="ghost"
          size="sm"
          isDisabled={isLoading}
          onPress={onClose}
        >
          Cancel
        </Button>
      </div>
    </Modal.Content>
  </Modal>
);
